module.exports = Object.freeze({
    SELECTED_WORDS_SIZE: 5,
    GAMES: [{ name: "fr-to-is", component: "GameSrcToTarget", srcLang: "fr", targetLang: "is", allowedErrors: 2 },
    { name: "is-to-fr", component: "GameSrcToTarget", srcLang: "is", targetLang: "fr", allowedErrors: 2 },
    { name: "is-to-Nfr", component: "GameOneToMany", srcLang: "is", targetLang: "fr", allowedErrors: 1 },
    { name: "fr-to-Nis", component: "GameOneToMany", srcLang: "fr", targetLang: "is", allowedErrors: 1 },
    { name: "path", component: "GamePath", srcLang: "fr", targetLang: "is", allowedErrors: 2 },
    { name: "spell", component: "GameSpell", srcLang: "fr", targetLang: "is", allowedErrors: 2 },
    { name: "syllables", component: "GameSyllables", srcLang: "fr", targetLang: "is", allowedErrors: 2 },
    { name: "hole", component: "GameHole", srcLang: "fr,en", targetLang: "is", allowedErrors: 2 }],
    ALPHABET: ["a", "á", "b", "d", "ð", "e", "é", "f", "g", "h", "i", "í", "j", "k", "l", "m", "n", "o", "ó", "p", "r", "s", "t", "u", "ú", "v", "x", "y", "ý", "þ", "æ", "ö"],
    PUNCTUATIONS: ["!", "?", ",", ".", ":", ";"]
});
